import { reducer as lastActivityReducer, MOUNT_POINT as CASE_LAST_ACTIVITY_POINT } from './case';

const reducers = {
    [CASE_LAST_ACTIVITY_POINT]: lastActivityReducer,
};

export default reducers;
